/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendVentureFundVariantDto } from '../../models/backend-venture-fund-variant-dto';
import { BackendVentureFundVariantRequestDto } from '../../models/backend-venture-fund-variant-request-dto';

export interface VentureFundsVentureFundVariantsCreate$XWwwFormUrlencoded$Params {
  body: BackendVentureFundVariantRequestDto;
}

export function ventureFundsVentureFundVariantsCreate$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params: VentureFundsVentureFundVariantsCreate$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendVentureFundVariantDto>> {
  const rb = new RequestBuilder(rootUrl, ventureFundsVentureFundVariantsCreate$XWwwFormUrlencoded.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendVentureFundVariantDto>;
    }),
  );
}

ventureFundsVentureFundVariantsCreate$XWwwFormUrlencoded.PATH = '/api/venture_funds/venture-fund-variants/';
